import { createApi } from "@reduxjs/toolkit/query/react";
import { prepareBaseQuery } from "./baseQueryWithReauth";

const expensesApi = createApi({
  reducerPath: "expenses",
  baseQuery: prepareBaseQuery("/expenses/"),
  tagTypes: ["Expenses", "Summary"],
  endpoints: (builder) => ({
    getExpenses: builder.query({
      query: (params = {}) => ({
        url: "",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.items
          ? [
              ...result.items.map((i) => ({ type: "Expenses", id: i._id })),
              { type: "Expenses", id: "LIST" },
            ]
          : [{ type: "Expenses", id: "LIST" }],
    }),
    getExpensesSummary: builder.query({
      query: (params = {}) => ({
        url: "summary",
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Summary", id: "LIST" }],
    }),
    createExpense: builder.mutation({
      query: (body) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "Expenses", id: "LIST" },
        { type: "Summary", id: "LIST" },
      ],
    }),
    updateExpense: builder.mutation({
      query: ({ id, body }) => ({
        url: `${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (res, err, { id }) => [
        { type: "Expenses", id },
        { type: "Expenses", id: "LIST" },
        { type: "Summary", id: "LIST" },
      ],
    }),
    archiveExpense: builder.mutation({
      query: (id) => ({
        url: `${id}/archive`,
        method: "PATCH",
      }),
      invalidatesTags: (res, err, id) => [
        { type: "Expenses", id },
        { type: "Expenses", id: "LIST" },
        { type: "Summary", id: "LIST" },
      ],
    }),
    restoreExpense: builder.mutation({
      query: (id) => ({
        url: `${id}/restore`,
        method: "PATCH",
      }),
      invalidatesTags: (res, err, id) => [
        { type: "Expenses", id },
        { type: "Expenses", id: "LIST" },
        { type: "Summary", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetExpensesQuery,
  useGetExpensesSummaryQuery,
  useCreateExpenseMutation,
  useUpdateExpenseMutation,
  useArchiveExpenseMutation,
  useRestoreExpenseMutation,
} = expensesApi;

export default expensesApi;
